import { QueryFiltersProps } from '../types';

export const API_PINNED_FILTERS_CONTEXT: Record<
  NonNullable<QueryFiltersProps['api']>,
  'SEARCH' | 'EVISEARCH_SEARCH'
> = {
  pilot: 'SEARCH',
  evisearch: 'EVISEARCH_SEARCH',
};
